import { FC } from 'react'

import { useAtom } from 'jotai'

import { PillSelectControlDropdown } from '@sequencehq/core-components'

import { TotalViewsTimescale } from '../../../types'
import { timescaleAtom } from './atoms'
import { TIMESCALE_LABELS } from './constants'

export const GraphTimescaleDropdown: FC = () => {
  const [timescale, setTimescale] = useAtom(timescaleAtom)

  return (
    <PillSelectControlDropdown
      initialValue={timescale}
      options={Object.entries(TIMESCALE_LABELS).map(([value, label]) => ({
        value,
        label
      }))}
      labelWhenNoSelection="Filter"
      onChange={value => setTimescale(value as TotalViewsTimescale)}
      showSearchInPopover={false}
      minWidth={170}
      enableSmartPlacement={false}
      placement="bottom-end"
    />
  )
}
